import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import '../styles/collection.css';

export default class BookController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: (props.match) ? props.match.params.bookId : null,
      name: props.name,
      author: props.author
    };
    this.image = React.createRef();
  }

  componentDidMount() {
    if (this.state.id) {
      this.load();
    }
  }

  load() {
    const that = this;
    fetch('/api/book/' + this.state.id, {credentials: 'same-origin', method: 'GET'})
      .then((res) => {
        res.json().then((book) => {
          that.setState(book);
        });
      });
  }

  save() {
    const that = this;
    const url = (this.state.id) ? `/api/book/${this.state.id}` : '/api/book';
    const data = new FormData();
    data.append('cover', this.image.current.files[0]);
    data.append('author', this.state.author);
    data.append('name', this.state.name);
    const options = {
      credentials: 'same-origin',
      method: 'POST',
      body: data
    };
    fetch(url, options).then((res) => {
      if (res.status === 201) {
        res.json().then((book) => that.props.onSave(book));
      }
    });
  }

  setAuthor(author) {
    this.setState({author});
  }

  setName(name) {
    this.setState({name});
  }

  getForm() {
    return [
      <input key='name' type='text' onChange={(e) => this.setName(e.target.value)} placeholder='name' />,
      <input key='author' type='text' onChange={(e) => this.setAuthor(e.target.value)} placeholder='author' />,
      <input id='book-cover' ref={this.image} key='book-cover' type='file' />,
      <label htmlFor='book-cover'>test</label>];
  }

  render() {
    return (<div className='note-form'>
      <div className='note-input'>
        {this.getForm()}
      </div>
      <button onClick={(e) => this.save()}>
        <span className='glyphicon glyphicon-floppy-disk'/>
      </button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/BookController.js